import { render, staticRenderFns } from "./Taller.vue?vue&type=template&id=ece7d704&"
import script from "./Taller.vue?vue&type=script&lang=js&"
export * from "./Taller.vue?vue&type=script&lang=js&"
import style0 from "./Taller.vue?vue&type=style&index=0&id=ece7d704&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports